<template>
    <div class="sweward">
        <Commondtitle title="环保管家服务"></Commondtitle>
        <div class="sw_content">
            <div
                v-for="(item,index) in dataArr"
                :key="index"
                :class="index%2 === 0? 'sw_item_left': 'sw_item_right'">
                <div class="sw_item_l_title">
                    <span class="sw_item_l_t_num">{{(index+1) | buwei }}.</span>
                    <span class="sw_item_l_t_font">{{ item.fserviceType | mangStyle }}</span>
                </div>
                <div class="sw_item_l_cent">
                    <div class="sw_item_l_c_img">
                        <img :src="IMGURL + item.fserviceImg" alt="">
                    </div>
                    <div class="sw_item_l_c_des">
                        <p>一家专注解决环保问题的综合性环保机构</p>
                        <h4>{{ item.fserviceProject }}</h4>
                        <div  class="sw_item_l_c_ul" v-html="item.fserviceContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Commondtitle from '../Commondtitle'
    import axios from '../../assets/js/baseaxios'
    import baseUrl from '../../assets/js/baseUrl'
    export default {
        name: "steward",
        data(){
            return{
                IMGURL: '',
                dataArr: [],
            }
        },
        filters:{
            buwei(val){
                if(val<10)return '0'+ val
                return val
            },
            mangStyle(val){
                switch (val) {
                    case 'A':
                        return '环保验收服务'
                    case 'B':
                        return '环保顾问服务'
                    case 'C':
                        return '环保管家服务'
                    case 'D':
                        return '服务升级'

                }
            }
        },
        mounted(){
            this.IMGURL = baseUrl.IMG_URL
            this.getData()
        },
        methods:{
            getData(){
                axios.get(`/api/service?page=1&limit=20`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items
                        this.dataArr = items
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            }
        },
        components:{
            Commondtitle
        }
    }
</script>

<style scoped>
    .sweward{
        width: 100%;
    }
    .sw_content{
        width: 1100px;
        margin: 0 auto;
    }
    .sw_item_left,
    .sw_item_right{
        margin-bottom: 70px;
    }
    .sw_item_left .sw_item_l_title span{
        float: left;
    }
    .sw_item_right .sw_item_l_title span{
        float: right;
    }
    .sw_item_l_title{
        height: 90px;
        line-height: 90px;
        margin-bottom: 60px;
    }
    .sw_item_left .sw_item_l_title span + span{
        margin-left: 20px;
    }
    .sw_item_right .sw_item_l_title span + span{
        margin-right: 20px;
    }
    .sw_item_l_title .sw_item_l_t_num{
        display: inline-block;
        width: 100px;
        height: 90px;
        background-color: #00B76B;
        font-size: 50px;
        color: #FFFFFF;
        text-align: center;
    }
    .sw_item_l_title .sw_item_l_t_font{
        font-size: 30px;
        color: #333;
    }
    .sw_item_l_cent{
        position: relative;
        height: 510px;
    }
    .sw_item_l_cent .sw_item_l_c_img{
        position: absolute;
        width: 744px;
        height: 510px;
        z-index: 1;
        overflow: hidden;
    }
    .sw_item_l_cent .sw_item_l_c_img img{
        position: absolute;
        display: block;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
    }
    .sw_item_l_cent .sw_item_l_c_des{
        position: absolute;
        width: 470px;
        top: 50%;
        z-index: 2;
        padding: 30px 30px 50px 40px;
        background-color: #fff;
        transform: translateY(-50%);
    }
    .sw_item_l_cent .sw_item_l_c_des>p{
        position: relative;
        color: #00B76B;
        font-size: 14px;
        margin-bottom: 24px;
    }
    .sw_item_l_cent .sw_item_l_c_des p:after{
        position: absolute;
        bottom: 0;
        right: 0;
        content: '';
        width: 80px;
        border-bottom: 1px dashed#979797;
    }
    .sw_item_l_cent .sw_item_l_c_des h4{
        color: #333;
        font-size: 30px;
        margin-bottom: 30px;
    }
    /*.sw_item_l_cent .sw_item_l_c_des .sw_item_l_c_ul p{*/
        /*line-height: 19px;*/
        /*font-size: 14px;*/
        /*color: #999;*/
        /*margin-bottom: 10px;*/
    /*}*/
    .sw_item_left .sw_item_l_cent .sw_item_l_c_img{
        left: 0;
    }
    .sw_item_left .sw_item_l_cent .sw_item_l_c_des{
        right: 0;
    }
    .sw_item_right .sw_item_l_cent .sw_item_l_c_img{
        right: 0;
    }
    .sw_item_right .sw_item_l_cent .sw_item_l_c_des{
        left: 0;
    }
</style>